import { EMPTY_FIELD } from 'constants/emptyField';

import { UsersMerchantAccessField } from 'pages/Users/components/UsersMerchantAccessField';
import { Box } from 'shared/mui/Box';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { UserRoleChip } from 'shared/mui/Chips';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField, FunctionField, TextField } from 'shared/react-admin/Fields';
import { User } from 'types/embedded/user';

export const UsersShowTable = (): JSX.Element => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '188px' } } }}>
      <TableRowWrapper label="Электронная почта">
        <TextField emptyText={EMPTY_FIELD} source="email" />
      </TableRowWrapper>
      <TableRowWrapper label="Роль">
        <FunctionField
          label="Роль"
          render={(record: User) => {
            if (!record?.rolesValues?.length) {
              return EMPTY_FIELD;
            }
            return (
              <Box display="flex" flexWrap="wrap" gap="4px">
                {record.rolesValues.map((val, index) => (
                  <UserRoleChip key={index} roleValue={val} />
                ))}
              </Box>
            );
          }}
          sortable={false}
        />
      </TableRowWrapper>
      <TableRowWrapper label="Доступ к мерчантам">
        <UsersMerchantAccessField />
      </TableRowWrapper>
      <TableRowWrapper label="Последняя активность">
        <DateTimeField inline source="lastActivity" />
      </TableRowWrapper>
      <TableRowWrapper label="Reddy">
        <TextField source="reddyNumber" />
      </TableRowWrapper>
      <TableRowWrapper label="Групповой email">
        <TextField emptyText={EMPTY_FIELD} source="corporateEmail" />
      </TableRowWrapper>
      <TableRowWrapper label="Дата создания">
        <DateTimeField inline source="createdAt" />
      </TableRowWrapper>
      <TableRowWrapper label="Дата редактир.">
        <DateTimeField inline source="updatedAt" />
      </TableRowWrapper>
    </CardTable>
  );
};
